import { loincCoding } from '#src/models/loinc.ts'
import { MMSE_DOMAINS } from '#src/terminology/instruments/instrumentTerminology.ts'
import {
  numberItem,
  ownCoding,
  scoreBand,
  totalScore,
} from '#src/terminology/instruments/templateParts.ts'
import type {
  InstrumentSection,
  InstrumentTemplate,
} from '#src/terminology/instruments/types.ts'

const SECTIONS: InstrumentSection[] = [
  {
    id: 'domains',
    items: MMSE_DOMAINS.map(([domain, label, max, hint]) =>
      numberItem(
        ownCoding(`mmse-${domain}`, `MMSE ${label.toLowerCase()}`),
        { min: 0, max },
        { label, hint }
      )
    ),
  },
]

export const MMSE_TEMPLATE: InstrumentTemplate = {
  id: 'mmse',
  version: '1',
  panel: loincCoding('72107-6', 'Mini-Mental State Examination [MMSE]'),
  title: 'Mini-Mental State Examination (MMSE)',
  copyright:
    'MMSE© 1975, 1998, 2001 Mini Mental LLC. Published by Psychological Assessment Resources, Inc. All rights reserved.',
  reference: 'https://cgatoolkit.ca/Uploads/ContentDocuments/MMSE.pdf',
  sections: SECTIONS,
  total: totalScore({
    templateId: 'mmse',
    coding: loincCoding('72106-8', 'Total score [MMSE]'),
    sections: SECTIONS,
    completeness: { requireAll: true },
    bands: [
      scoreBand({ min: 24 }, 'mmse-normal', 'Normal', 'green'),
      scoreBand(
        { min: 18, max: 23 },
        'mmse-mild-impairment',
        'Mild Impairment',
        'yellow'
      ),
      scoreBand(
        { min: 10, max: 17 },
        'mmse-moderate-impairment',
        'Moderate Impairment',
        'orange'
      ),
      scoreBand(
        { max: 9 },
        'mmse-severe-impairment',
        'Severe Impairment',
        'red'
      ),
    ],
  }),
}
